import viewController from 'sky-engine/views/viewController'

import DeliveryDeployDetail from './deliveryDeployDetail'

const SkyDeliveryDeployProjectDetailController = {
  name: 'SkyDeliveryDeployProjectDetailController',
  components: {
    DeliveryDeployDetail
  },
  extends: viewController,
  provide() {
    return {
      DeliveryDeployDetail: this
    }
  },
  props: {
    views: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  created() {},
  data() {
    return {}
  },
  mounted() {},
  methods: {
    autoRefresh() {
      this.$refs.deliveryDeployDetail.refresh()
    },
    renderContent(h) {
      return <delivery-deploy-detail ref="deliveryDeployDetail"></delivery-deploy-detail>
    }
  }
}

export default SkyDeliveryDeployProjectDetailController
